const editors = store => {
  store.on("@init", () => ({ editors: [] }));
  store.on("editors/set", (_, editors) => {
    return { editors };
  });
};

export default editors;
